import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux'
import { Redirect, Route } from 'react-router-dom';
import {
    IonContent,
    IonIcon,
    IonLabel,
    IonRouterOutlet,
    IonTabBar,
    IonTabButton,
    IonTabs,
    IonLoading,
    IonToast,
    IonPage,
    IonHeader,
    IonToolbar,
    IonButtons,
    IonBackButton,
    IonTitle,
    IonSegment,
    IonSegmentButton,
    IonRow,
    IonCol,
    IonButton,
    IonCheckbox,
    IonFab,
    IonFabButton,
    IonModal,
    IonFooter,
    IonText,
    IonAlert,
    IonInfiniteScroll,
    IonInfiniteScrollContent,
    IonTextarea,
    IonSearchbar
} from '@ionic/react';
import { homeOutline, cartOutline, cubeOutline, receiptOutline, arrowUp, closeOutline, add, person, barcode, business, locationOutline, trashOutline, createOutline, search } from 'ionicons/icons';
import ProductActions from '../../../actions/ProductActions';
import PosActions from '../../../actions/PosActions';

import { getLoginApp } from '../../../utils/functions';
import Select from 'react-select'
import { DebounceInput } from 'react-debounce-input';

interface IProps {
    setData_: any;
    get_: any;
    post_: any;
    get_default: any;
}

interface IState {
    bussines_locations: any;
    categories: any;
    subcategories: any;
    ModalCategorieShow: any;
    fieldsCategorie: any;
    formErrors: any;
    datalogin: any;
    pages: any;
    total_rows: any;
    searchText: any;
    pageSize: any;
    current_count_data: any;
    categoriesDB: any;
    data_pagin_categoriesDB: any;
    alertDestroy: any;

}

class Categories extends React.Component<IProps, IState> {
    ModalUnit: React.RefObject<HTMLIonModalElement>;
    ionInfiniteScrollRefData: React.RefObject<HTMLIonInfiniteScrollElement>;

    constructor(props: any) {
        super(props)
        this.ModalUnit = React.createRef<HTMLIonModalElement>();
        this.ionInfiniteScrollRefData = React.createRef<HTMLIonInfiniteScrollElement>();

        this.state = {
            bussines_locations: [],
            categories: [],
            ModalCategorieShow: false,
            fieldsCategorie: null,
            formErrors: {},
            datalogin: props.datalogin,

            pages: props.pages,
            total_rows: props.total_rows,
            searchText: props.searchText,
            pageSize: props.pageSize,
            current_count_data: props.current_count_data,

            categoriesDB: [],
            data_pagin_categoriesDB: [],
            alertDestroy: false,
            subcategories: []
        }
    }

    componentDidMount() {

        this.setState({
            ModalCategorieShow: false,
            fieldsCategorie: {
                id: null,
                name: '',
                short_code: '',
                add_as_sub_cat: 0,
                parent_id: null,
                is_sub_sub: 0,
                sub_parent_id: null,
            },
            datalogin: getLoginApp(),

            pages: 0,
            pageSize: 10,
            total_rows: 0,
            searchText: '',
            current_count_data: 0,
            alertDestroy: false
        });
        setTimeout(this.getDataPaginInit.bind(this), 1000);

    }

    getDataPaginInit() {

        if (this.state.total_rows != 0 && this.state.current_count_data == this.state.total_rows && this.state.pages != 0) {
            if (this.ionInfiniteScrollRefData.current) {
                this.ionInfiniteScrollRefData.current.complete();
            }
            return;
        }

        this.props.get_({
            user_id: this.state.datalogin.id,
            typeOption: 'get_list_categories',
            search: this.state.searchText,
            pageSize: this.state.pageSize,
            pages: this.state.pages,
            current_count_data: this.state.current_count_data,
            view_active: 'dashboard_products/configuration'
        }, "api/get_list_categories");
    }

    UNSAFE_componentWillReceiveProps(nextProps: any) {
        this.setState({
            bussines_locations: nextProps.data.data_default && nextProps.data.data_default.businessLocations ? nextProps.data.data_default.businessLocations : [],
            categories: nextProps.data.data_default && nextProps.data.data_default.categories ? nextProps.data.data_default.categories : [],
            subcategories: nextProps.data.data_default && nextProps.data.data_default.subcategories ? nextProps.data.data_default.subcategories : [],
            categoriesDB: nextProps.data.categoriesDB && nextProps.data.categoriesDB ? nextProps.data.categoriesDB : [],
            data_pagin_categoriesDB: nextProps.data.data_pagin_categoriesDB && nextProps.data.data_pagin_categoriesDB ? nextProps.data.data_pagin_categoriesDB : [],
            pages: nextProps.data.categoriesDB && nextProps.data.categoriesDB.pages ? nextProps.data.categoriesDB.pages : 0,
            total_rows: nextProps.data.categoriesDB && nextProps.data.categoriesDB.total_rows ? nextProps.data.categoriesDB.total_rows : 0,
            current_count_data: nextProps.data.data_pagin_categoriesDB ? nextProps.data.data_pagin_categoriesDB.length : 0
        });

        if (nextProps.data.view_active == "dashboard_products/categories") {
            if (nextProps.data.refresh_list) {
                this.setState({
                    pages: 0,
                    pageSize: 10,
                });

                setTimeout(this.getDataPaginInit.bind(this), 1000);
            }
            if (this.ionInfiniteScrollRefData.current) {
                if (nextProps.data.concat_list) {
                    this.ionInfiniteScrollRefData.current.complete();
                }
            }
        }

    }

    edit_categorie(categorie: any) {

        let fieldsCategorie = {
            id: categorie.id,
            name: categorie.name,
            short_code: categorie.short_code,
            add_as_sub_cat: categorie.parent_id && categorie.parent_id != 0 ? 1 : 0,
            parent_id: categorie.parent_id,
            is_sub_sub: categorie.is_sub_sub,
            sub_parent_id: categorie.sub_parent_id,

        };

        this.setState({
            ModalCategorieShow: true,
            fieldsCategorie: fieldsCategorie
        });

    }

    render_categories(row: any, key: any) {
        return (
            <div className='card_line' key={key}>
                <IonRow >
                    <IonCol col-12 size='12'>
                        <label className='text-sm font-medium text-g60'><strong>Nombre:</strong> {row.name}</label> <br />
                        <label className='text-sm font-medium text-g60'><strong>Código:</strong> {row.short_code}</label>
                    </IonCol>
                    <IonCol col-12 size='12' className='text-center'>
                        <IonButton size='small'
                            onClick={() => this.edit_categorie(row)}
                        >
                            <div>
                                <IonIcon
                                    color="#ffffff"
                                    slot="icon-only"
                                    icon={createOutline} // Puedes cambiar 'add' por 'createOutline' si tienes ese icono
                                    size="small"
                                />
                            </div>
                        </IonButton>
                        <IonButton size='small' color={'danger'}
                            onClick={
                                e => this.setState({ alertDestroy: true, fieldsCategorie: row })
                            }
                        >
                            <div>
                                <IonIcon
                                    color="light"
                                    slot="icon-only"
                                    icon={trashOutline}
                                    size="small"
                                />
                            </div>
                        </IonButton>
                    </IonCol>
                </IonRow>
            </div >
        );
    }


    handleChangeUnit(event: any) {
        let fieldsCategorie = this.state.fieldsCategorie;
        fieldsCategorie[event.target.name] = event.target.value;
        if (event.target.name == 'add_as_sub_cat') {
            fieldsCategorie['parent_id'] = null;
            fieldsCategorie['is_sub_sub'] = 0;
            fieldsCategorie['sub_parent_id'] = null;
        }
        if (event.target.name == 'is_sub_sub') {
            fieldsCategorie['add_as_sub_cat'] = 0;
            fieldsCategorie['parent_id'] = null;
            fieldsCategorie['sub_parent_id'] = null;
        }
        this.setState({
            fieldsCategorie: fieldsCategorie
        });
    }

    openModalCategories(row: any) {
        this.setState({
            ModalCategorieShow: true,
            fieldsCategorie: {
                id: null,
                name: '',
                short_code: '',
                add_as_sub_cat: 0,
                parent_id: null,
                is_sub_sub: 0,
                sub_parent_id: null,
            }
        });
    }

    dismissModalCategorie() {
        this.setState({
            ModalCategorieShow: false,
            fieldsCategorie: {
                id: null,
                name: '',
                short_code: '',
                add_as_sub_cat: 0,
                parent_id: null,
                is_sub_sub: 0,
                sub_parent_id: null,
            }
        });
    }

    SaveDataPost() {
        let fieldsCategorie = this.state.fieldsCategorie;
        let error = false;
        let formErrors: any = {};
        if (this.state.fieldsCategorie && this.state.fieldsCategorie.name == "") { formErrors['name'] = "*Campo Requerido"; error = true };

        if (error) {
            this.setState({
                formErrors: formErrors
            });
        } else {

            if (fieldsCategorie.id) {
                this.props.post_({
                    typeOption: 'updateDataCategorie',
                    action: 'update',
                    user_id: this.state.datalogin.id,
                    fieldsCategorie: this.state.fieldsCategorie,
                    view_active: 'dashboard_products/categories'
                }, "api/updateDataCategorie");
            } else {
                this.props.post_({
                    typeOption: 'saveDataCategorie',
                    action: 'create',
                    user_id: this.state.datalogin.id,
                    fieldsCategorie: this.state.fieldsCategorie,
                    view_active: 'dashboard_products/categories'
                }, "api/saveDataCategorie");
            }
            this.setState({
                ModalCategorieShow: false,
            });
        }


    }

    SendDestroy() {
        this.props.post_({
            typeOption: 'destroyDataCategorie',
            action: 'destroy',
            user_id: this.state.datalogin.id,
            fieldsCategorie: this.state.fieldsCategorie,
            view_active: 'dashboard_products/categories'
        }, "api/destroyDataCategorie");
        this.setState({
            alertDestroy: false
        });
    }

    setSearchText(e: any) {
        const value = e.target.value;
        this.setState({
            searchText: value.toLowerCase(),
            pages: 0,
            pageSize: 10,

        });

        setTimeout(this.getDataPaginInit.bind(this), 1000);
    }

    render() {
        const {
            fieldsCategorie,
            ModalCategorieShow,
            bussines_locations,
            categories,
            formErrors,
            data_pagin_categoriesDB,
            categoriesDB,
            total_rows,
            current_count_data,
            pages,
            alertDestroy,
            subcategories,
            searchText
        } = this.state;

        let data_render_categories = [];
        if (data_pagin_categoriesDB && data_pagin_categoriesDB.length > 0) {
            data_render_categories = [];
            data_render_categories = data_pagin_categoriesDB.map((val: any, key: any) =>
                this.render_categories(val, key)
            );
        };
        return (
            <IonContent>
                <IonAlert
                    backdropDismiss={false}
                    isOpen={alertDestroy}
                    header={'Confirmar'}
                    //subHeader={'Verifique si conexión a internet.'}
                    message={'¿Desea eliminar la categoria?'}
                    buttons={[
                        /*{
                          text: 'Conservar',
                          handler: e => {
                            this.SendCon(e);
                          }
                        },*/
                        {
                            text: 'Si',
                            handler: (e) => {
                                this.SendDestroy();
                            }
                        },
                        {
                            text: 'No',
                            handler: e => {
                                this.setState({
                                    alertDestroy: false
                                });
                            }
                        }
                    ]}
                />
                <IonRow>
                    <IonCol col-12 size='12' style={{ textAlign: "center" }}>
                        <div style={{ display: "none" }}>
                            <IonSearchbar onIonChange={e => this.setSearchText(e)} value={searchText}></IonSearchbar>
                        </div>
                    </IonCol>
                    <IonCol col-12 size='12' class='divflex'>
                        <IonIcon icon={search} className='iconseach'></IonIcon>
                        <DebounceInput
                            className='btn_search'
                            placeholder={'Buscar por nombre'}
                            minLength={2}
                            debounceTimeout={2000}
                            value={searchText}
                            onChange={e => this.setSearchText(e)} />
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol col-12 size='12' >
                        {data_render_categories && data_render_categories.length > 0 ? data_render_categories : <IonCol col-12 size='12' style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', minHeight: '100px' }}>
                            <IonText color="medium" style={{ fontWeight: 'bold', textAlign: 'center' }}>
                                <h5 style={{ margin: 0, fontWeight: 'bold' }}>No hay valores disponibles</h5>
                            </IonText>
                        </IonCol>}
                    </IonCol>
                    <div
                        style={{
                            position: 'fixed',
                            bottom: '16px',
                            right: '16px',

                        }}
                    >
                        <IonFabButton color="primary">
                            <IonIcon icon={add}></IonIcon>
                        </IonFabButton>
                    </div>
                </IonRow>
                <IonInfiniteScroll threshold="50px" ref={this.ionInfiniteScrollRefData}
                    onIonInfinite={(event) => {
                        this.getDataPaginInit();
                    }}
                >
                    <IonInfiniteScrollContent loadingText="Cargando mas datos..." loadingSpinner="bubbles"></IonInfiniteScrollContent>

                </IonInfiniteScroll>
                <IonModal onDidDismiss={this.dismissModalCategorie.bind(this)} isOpen={ModalCategorieShow} ref={this.ModalUnit} trigger="open-modal">
                    <IonContent className="ion-padding">
                        <IonHeader>
                            <IonToolbar color="primary">
                                <IonTitle>{fieldsCategorie && fieldsCategorie.id ? 'Editar Categoria' : 'Nueva Categoria'}</IonTitle>
                                <IonButton slot="end" style={{ textAling: "center", marginRight: '10px' }} onClick={this.dismissModalCategorie.bind(this)}>
                                    <IonIcon icon={closeOutline}></IonIcon>
                                </IonButton>
                            </IonToolbar>
                        </IonHeader>

                        <IonRow>
                            <IonCol col-12 size='12'>
                                <label>Nombre: </label>
                                <div className="inputWithIcon">
                                    <IonIcon slot="start" className='inputWithIconIcono' icon={createOutline} aria-hidden="true"></IonIcon>
                                    <input
                                        className='inputform'
                                        type="text"
                                        placeholder="Nombre"
                                        onChange={this.handleChangeUnit.bind(this)}
                                        value={(fieldsCategorie && fieldsCategorie.name) ?? ""}
                                        name="name" />
                                </div>
                                {formErrors && formErrors.name && (
                                    <>
                                        <IonText color="danger" className="ion-padding-start">
                                            <small>{formErrors.name}</small>
                                        </IonText>
                                        <br />
                                    </>
                                )}
                            </IonCol>
                            <IonCol col-12 size='12'>
                                <label>Código: </label>
                                <div className="inputWithIcon">
                                    <IonIcon slot="start" className='inputWithIconIcono' icon={createOutline} aria-hidden="true"></IonIcon>
                                    <input
                                        className='inputform'
                                        type="text"
                                        placeholder="Código"
                                        onChange={this.handleChangeUnit.bind(this)}
                                        value={(fieldsCategorie && fieldsCategorie.short_code) ?? ""}
                                        name="short_code" />
                                </div>
                            </IonCol>
                            <IonCol col-12 size='12'>
                                <IonCheckbox
                                    onIonChange={e => this.handleChangeUnit({ target: { name: 'add_as_sub_cat', value: e.detail.checked ? 1 : 0 } })}
                                    checked={fieldsCategorie && fieldsCategorie.add_as_sub_cat && fieldsCategorie.add_as_sub_cat == 1 ? true : false}
                                    labelPlacement="start" alignment="center">
                                    Es sub-categoria 1
                                </IonCheckbox>
                            </IonCol>
                            {
                                (fieldsCategorie && fieldsCategorie.add_as_sub_cat && fieldsCategorie.add_as_sub_cat == 1) ? (
                                    <IonCol col-12 size='12'>
                                        <label>Categoria Principal: </label>
                                        <Select
                                            className='inputformselect'
                                            onChange={(e: any) => this.handleChangeUnit({ target: { name: 'parent_id', value: e.value } })}
                                            placeholder="Categoria Principal"
                                            name='parent_id'
                                            menuPortalTarget={document.querySelector('body')}
                                            isSearchable={false}
                                            options={
                                                categories && categories.map((value: any) => (
                                                    { label: value.name, value: value.id }
                                                ))
                                            }
                                            styles={{
                                                menu: provided => ({ ...provided, zIndex: 9999, color: 'black' }),
                                            }}
                                            defaultValue={fieldsCategorie && fieldsCategorie.parent_id ?
                                                categories && categories.length > 0 ?
                                                    {
                                                        label: categories.filter((item: any) => item.id == fieldsCategorie.parent_id)[0].name, value: categories.filter((item: any) => item.id == fieldsCategorie.parent_id)[0].id
                                                    }
                                                    : null
                                                : null
                                            }
                                        />
                                    </IonCol>
                                ) : null
                            }

                            <IonCol col-12 size='12'>
                                <IonCheckbox
                                    onIonChange={e => this.handleChangeUnit({ target: { name: 'is_sub_sub', value: e.detail.checked ? 1 : 0 } })}
                                    checked={fieldsCategorie && fieldsCategorie.is_sub_sub && fieldsCategorie.is_sub_sub == 1 ? true : false}
                                    labelPlacement="start" alignment="center">
                                    Es sub-categoria 2
                                </IonCheckbox>
                            </IonCol>
                            {
                                (fieldsCategorie && fieldsCategorie.is_sub_sub && fieldsCategorie.is_sub_sub == 1) ? (
                                    <IonCol col-12 size='12'>
                                        <label>Sub-Categoria 2: </label>
                                        <Select
                                            className='inputformselect'
                                            onChange={(e: any) => this.handleChangeUnit({ target: { name: 'sub_parent_id', value: e.value } })}
                                            placeholder="Sub-Categoria 2"
                                            name='sub_parent_id'
                                            menuPortalTarget={document.querySelector('body')}
                                            isSearchable={false}
                                            options={
                                                subcategories && subcategories
                                                    .filter((value: any) => value.id !== fieldsCategorie.id)
                                                    .map((value: any) => (
                                                        { label: value.name, value: value.id }
                                                    ))
                                            }
                                            styles={{
                                                menu: provided => ({ ...provided, zIndex: 9999, color: 'black' }),
                                            }}
                                            defaultValue={fieldsCategorie && fieldsCategorie.sub_parent_id ?
                                                subcategories && subcategories.length > 0 ?
                                                    {
                                                        label: subcategories.filter((item: any) => item.id == fieldsCategorie.sub_parent_id)[0].name, value: subcategories.filter((item: any) => item.id == fieldsCategorie.sub_parent_id)[0].id
                                                    }
                                                    : null
                                                : null
                                            }
                                        />
                                    </IonCol>
                                ) : null
                            }


                        </IonRow>
                    </IonContent>
                    <IonFooter collapse="fade" className='footerfixed'>
                        <IonToolbar>
                            <IonButtons slot="start">
                                <IonButton color="dark" onClick={() => this.dismissModalCategorie()}>
                                    Cancel
                                </IonButton>
                            </IonButtons>
                            <IonButtons slot="end">
                                <IonButton color="primary" strong={true} onClick={() => this.SaveDataPost()}>
                                    Guardar
                                </IonButton>
                            </IonButtons>
                        </IonToolbar>
                    </IonFooter>
                </IonModal>
                <div
                    style={{
                        position: 'fixed',
                        bottom: '16px',
                        right: '16px',

                    }}
                >
                    <IonFabButton onClick={(e) => this.openModalCategories(e)} color="primary">
                        <IonIcon icon={add}></IonIcon>
                    </IonFabButton>
                </div>
            </IonContent>
        );
    };
}

const mapStateToProps = (state: any) => {
    return {
        data: state.data,
        post_: PropTypes.func.isRequired,

    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        setData_: (data: any, name: string) => dispatch(ProductActions.setData(data, name)),
        get_: (fields: any, controller: string) => dispatch(ProductActions.get_(fields, controller)),
        post_: (data: any, controller: string) => dispatch(ProductActions.post_(data, controller)),
        get_default: (fields: any, controller: string) => dispatch(PosActions.get_(fields, controller)),

    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Categories);
